
export const justCheese = {
  id: "1d851ffb-8b75-43d9-8a0f-a06146ee7b40",
  name: "Just Cheese",
  price: 12,
  toppingImages: [],
  toppingPrices: [],
  toppings: []
}

export const pepperoni = {
    count: 1,
    id: "38e0d9e3-2daf-4d0f-9e78-be40629663c8",
    name: "The Regular",
    price: 12.75,
    toppingImages: ['images/toppings/pepperoni_topping.png'],
    toppingPrices: [0.75],
    toppings: ['Pepperoni']
}

export const meatLovers = {
  id: "dc5b7848-c2f8-47fd-a005-9e1ba2827769",
  name: "Meat Lovers",
  price: 15.25,
  toppingImages: ['images/toppings/pepperoni_topping.png', 'images/toppings/ham_topping.png', 'images/toppings/italianSausage_topping.png', 'images/toppings/bacon_topping.png'],
  toppingPrices: [0.75, 0.75, 0.75, 1],
  toppings: ['Pepperoni', 'Ham', 'Italian Sausage', 'Bacon']
}

export const veggieLovers = {
  id: "a36a9cf5-0a1a-4433-87d2-fdabf80dd45f",
  name: "Veggie Lovers",
  price: 15.30,
  toppingImages: ['images/toppings/jalapenos_topping.png', 'images/toppings/mushrooms_topping.png', 'images/toppings/olives_topping.png', 'images/toppings/onions_topping.png', 'images/toppings/spinach_topping.png', 'images/toppings/basil_topping.png'],
  toppingPrices: [0.6, 0.6, 0.6, 0.6, 0.4, 0.5],
  toppings: ['Jalapeños', 'Mushroom', 'Olives', 'Onions', 'Spinach', 'Basil']
}

export const hawaiianPizza = {
  id: "18c87572-d775-42b4-bad6-f465966eb283",
  name: "Hawaiian Pizza",
  price: 13.35,
  toppingImages: ['images/toppings/pepperoni_topping.png', 'images/toppings/pineapple_topping.png'],
  toppingPrices: [0.75, 0.6],
  toppings: ['Pepperoni', 'Pineapple']
}

export const byTheBay = {
  id: "f27cc95f-d333-4d25-b392-cbb24b67f3ef",
  name: "By The Bay",
  price: 15,
  toppingImages: ['images/toppings/anchovies_topping.png', 'images/toppings/shrimp_topping.png'],
  toppingPrices: [1.75, 1.25],
  toppings: ['Anchovies', 'Shrimp']
}

export const sweetNSpicy = {
  id: "0cbcc652-d18d-4004-b73a-8de4be467eba",
  name: "Sweet 'N Spicy",
  price: 13.20,
  toppingImages: ['images/toppings/pineapple_topping.png', 'images/toppings/jalapenos_topping.png'],
  toppingPrices: [0.6, 0.6],
  toppings: ['Pineapple', 'Jalapeños']
}

export const supreme = {
  id: "1129c539-c95b-4309-9014-57cc8f8fa575",
  name: "Supreme",
  price: 16.45,
  toppingImages: ['images/toppings/pepperoni_topping.png', 'images/toppings/ham_topping.png', 'images/toppings/italianSausage_topping.png', 'images/toppings/mushrooms_topping.png', 'images/toppings/olives_topping.png', 'images/toppings/onions_topping.png', 'images/toppings/spinach_topping.png'],
  toppingPrices: [0.75, 0.75, 0.75, 0.6, 0.6, 0.6, 0.4],
  toppings: ['Pepperoni', 'Ham', 'Italian Sausage', 'Mushroom', 'Olives', 'Onions', 'Spinach']
}

export const theWorks = {
  id: "db709e6a-2c89-4dc1-99c2-193ff2b8c492",
  name: "The Works",
  price: 23.40,
  toppingImages: ["images/toppings/anchovies_topping.png", "images/toppings/bacon_topping.png", "images/toppings/basil_topping.png", "images/toppings/feta_topping.png", "images/toppings/ham_topping.png", "images/toppings/italianSausage_topping.png", "images/toppings/jalapenos_topping.png", "images/toppings/mushrooms_topping.png", "images/toppings/olives_topping.png", "images/toppings/onions_topping.png", "images/toppings/parmesan_topping.png", "images/toppings/pepperoni_topping.png", "images/toppings/pineapple_topping.png", "images/toppings/shrimp_topping.png", "images/toppings/spinach_topping.png"],
  toppingPrices: [0.75, 0.75, 1, 0.75, 1.75, 1.25, 0.75, 0.5, 0.6, 0.6, 0.6, 0.6, 0.6, 0.5, 0.4],
  toppings: ["Pepperoni", "Ham", "Bacon", "Italian Sausage",   "Anchovies", "Shrimp", "Feta", "Parmesan", "Jalapeños", "Mushroom", "Olives", "Onions", "Pineapple", "Basil", "Spinach"]
}